class ResetPassswordModel {
  constructor(email) {
    this.email = email;
  }
}

export default ResetPassswordModel;
